export var CalculatorEvents;
(function (CalculatorEvents) {
    CalculatorEvents["CONTINUE"] = "continue";
    CalculatorEvents["SAVE"] = "save";
    CalculatorEvents["HAS_NEW_CALCULATION"] = "has new calculation";
})(CalculatorEvents || (CalculatorEvents = {}));
export default CalculatorEvents;
//# sourceMappingURL=CalculatorEvents.js.map